import { DepressionContentPage } from "@/components/DepressionContentPage";

const DepressionTreatmentConsultation = () => (
  <DepressionContentPage
    seo={{
      title:
        "What Happens During a Depression Treatment Consultation | Neuro Wellness",
      description:
        "You don't need to know which treatment you need before calling us. Learn what happens during a depression treatment consultation and what to expect.",
      canonical: "/depression-treatment-consultation",
      keywords:
        "depression treatment consultation, what to expect, first appointment, TMS consultation, Coral Springs",
    }}
    badge="Your First Conversation"
    heroTitle="What Happens During a Depression Treatment Consultation?"
    heroSubtitle="You don't need to know which treatment you need before calling us. That's what the consultation is designed to help you understand."
    sections={[
      {
        variant: "callout",
        callout:
          "The consultation is a conversation, not a commitment. Its purpose is to understand your situation and discuss which options may be worth considering.",
      },
      {
        heading: "What We Discuss",
        variant: "text",
        body: (
          <p>
            During a consultation, we may review your current symptoms,
            diagnosis, treatment history, medication history, therapy history,
            any previous TMS, current psychiatric providers, treatment goals,
            and questions about treatment options, scheduling, insurance, and
            self-pay. The goal is to understand the full picture before
            discussing recommendations.
          </p>
        ),
      },
      {
        heading: "What Happens During the Conversation",
        variant: "steps",
        steps: [
          {
            title: "We listen to your story",
            body: "Your symptoms, what you've tried, what helped, what didn't, and what you're hoping for.",
          },
          {
            title: "We explain the options",
            body: "We describe treatments that may be relevant to your situation in plain language.",
          },
          {
            title: "We discuss logistics",
            body: "Scheduling, insurance, self-pay questions, and what the next steps would look like.",
          },
          {
            title: "You decide what's next",
            body: "There's no pressure to commit to anything during this conversation.",
          },
        ],
      },
      {
        heading: "I'm Calling for Myself",
        variant: "text",
        body: (
          <p>
            If you're calling for yourself, you're in the right place. You don't
            need to have everything figured out. We'll guide the conversation
            and help you understand what may be appropriate.
          </p>
        ),
      },
      {
        heading: "I'm Calling for Someone I Love",
        variant: "text",
        body: (
          <p>
            If you're calling on behalf of a family member, you can learn
            general information about our services and the consultation process.
            The patient must consent to and participate in treatment, but
            gathering information is something you can do now.
          </p>
        ),
      },
      {
        heading: "What You Need for the First Call",
        variant: "text",
        body: (
          <p>
            You don't need a complete medical history for the first inquiry. A
            rough sense of what you've tried and what's been happening is
            enough. Detailed records, insurance information, and clinical
            documentation may be collected later in the process — not during the
            first conversation.
          </p>
        ),
      },
    ]}
    faq={[
      {
        question: "Do I need a referral for a consultation?",
        answer:
          "You can contact us directly to schedule a consultation. If you have a current psychiatrist or therapist, we can coordinate with them, but a formal referral is not required to start the conversation.",
      },
      {
        question: "Is the consultation free?",
        answer:
          "We offer a free phone consultation to help you understand your options. There's no obligation to proceed with treatment.",
      },
      {
        question: "Will I be pressured to choose a treatment?",
        answer:
          "No. The consultation is about understanding your situation and discussing options. The decision to pursue any treatment is yours.",
      },
      {
        question: "Can a family member join the consultation?",
        answer:
          "With the patient's consent, family members may participate. We encourage involving loved ones when it's helpful to the patient.",
      },
    ]}
    relatedLinks={[
      {
        title: "Depression Treatment Options",
        href: "/depression-treatment-options",
      },
      {
        title: "Depression Treatment Cost",
        href: "/depression-treatment-cost",
      },
      {
        title: "Insurance for TMS & Depression Treatment",
        href: "/insurance-for-tms-depression-treatment",
      },
      {
        title: "Helping Someone You Love With Depression",
        href: "/helping-someone-with-depression",
      },
    ]}
    finalCtaHeading="Schedule a Private Consultation"
    finalCtaText="You don't have to know which treatment you need before reaching out. Start with a conversation — we'll help you understand what may be appropriate."
  />
);

export default DepressionTreatmentConsultation;
